<template>
  <div class="categories">
    <div
      v-for="(category, categoryKey) in categories"
      :key="category.id"
      class="category-item"
      :class="{active: currentCategory && currentCategory.id === category.id && useActive}"
      :style="{transitionDelay: `${(categoryKey + 1) * 0.1}s`}"
      @click="openCategory(category)"
    >
      <span class="icon" :style="{backgroundImage: `url(${category.icon})`}"></span>
      <span>{{ category.name }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    useActive: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions(["changeCategory", "openCategory"]),
  },
  computed: {
    ...mapState(["categories", "currentCategory"]),
  },
};
</script>

<style lang="scss" scoped>
.categories {
  width: 24vw;
  padding: 3vw 3.5vw 5vw 6vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .category-item {
    position: relative;
    padding: 0 2.9vw;
    color: #003274;
    font-size: 1.05vw;
    font-weight: bold;
    line-height: 1.2vw;
    transition: 0.4s;
    cursor: pointer;
    transform-origin: 80% center;
    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -1.3vw;
      width: 2.3vw;
      height: 2.3vw;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      transition: 0.3s;
    }
    &:hover,
    &.active {
      color: #dd2211;
      transform: scale(1.4);
    }
  }
  &.hidden {
    .category-item {
      opacity: 0;
      transform: translateX(100%);
    }
  }
  &:not(.hidden-active) {
    .category-item {
      transition-delay: 0s !important;
    }
  }
}
#portrait .categories {
  width: auto;
  overflow-x: scroll;
  padding: 40px 20px;
  display: block;
  white-space: nowrap;
  .category-item {
    display: inline-block;
    width: 140px;
    padding: 0;
    margin-right: 20px;
    vertical-align: top;
    .icon {
      display: block;
      position: static;
      width: 50px;
      height: 50px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 10px;
    }
    span {
      display: block;
      text-align: center;
      white-space: normal;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .categories {
    width: 33vw;
    .category-item {
      font-size: inherit;
      line-height: inherit;
      &:hover,
      &.active {
        color: #dd2211;
        transform: scale(1.3);
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .categories {
    .category-item {
      &:hover,
      &.active {
        transform: scale(1.2);
      }
    }
  }
}
@media only screen and (max-width: 7680px) {
  #portrait .categories {
    .category-item {
      width: 24vw;
    }
  }
}
@media only screen and (max-width: 480px) {
  #portrait .categories {
    .category-item {
      width: 34vw;
      .icon {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>